// // import React, { useState, useEffect, useRef } from "react";
// // import axios from "axios";
// // import sound from "../../../../images/alaram.mp3";

// // const MobileOrderspage = () => {
// //     const [isHovered, setIsHovered] = useState(false);
// //     const [expandedOrder, setExpandedOrder] = useState(null);
// //     const [orders, setOrders] = useState([]);
// //     const [checkedItems, setCheckedItems] = useState({});
// //     const [vendorId, setVendorId] = useState(null);
// //     const scrollContainerRef = useRef(null);
// //     const notificationSound = new Audio(sound);

// //     useEffect(() => {
// //         const storedVendorId = localStorage.getItem("vendorId");
// //         setVendorId(storedVendorId);
// //     }, []);

// //     const handleCheckboxChange = (listId) => {
// //         setCheckedItems((prev) => ({
// //             ...prev,
// //             [listId]: !prev[listId],
// //         }));
// //         //console.log("Selected List ID:", listId);
// //     };


// //     const handleCancelSingleOrder = async (listId) => {
// //         try {
// //             const token = localStorage.getItem("authToken"); // ✅ Adjust key name if needed

// //             if (!token) {
// //                 alert("Authorization token not found!");
// //                 return;
// //             }

// //             const response = await fetch(
// //                 `https://backend.maamaas.com/food/orderscancellationlist/edit/${listId}`,
// //                 {
// //                     method: "PUT",
// //                     headers: {
// //                         "Content-Type": "application/json",
// //                         "Authorization": `Bearer ${token}`, // 👈 Add token here
// //                     },
// //                     body: JSON.stringify({
// //                         status: "Cancelled",
// //                     }),
// //                 }
// //             );

// //             if (!response.ok) {
// //                 console.error(`Failed to cancel order ${listId}`);
// //                 alert(`Failed to cancel order ${listId}`);
// //             } else {
// //                 //console.log(`Order ${listId} cancelled successfully.`);
// //                 alert(`Order ${listId} has been cancelled.`);
// //                 // Optional: Uncheck after cancellation
// //                 setCheckedItems((prev) => {
// //                     const updated = { ...prev };
// //                     delete updated[listId];
// //                     return updated;
// //                 });
// //             }
// //         } catch (error) {
// //             console.error("Error cancelling order:", error);
// //         }
// //     };


// //     const handleOrderClick = (order) => {
// //         const id = order.orderId || order.cartId; // normalize ID
// //         //console.log("Clicked order:", order); // ✅ debug

// //         if (expandedOrder && expandedOrder.id === id) {
// //             //console.log("Collapsing order:", id);
// //             setExpandedOrder(null); // collapse
// //         } else {
// //             //console.log("Expanding order:", id);
// //             setExpandedOrder({ ...order, id }); // expand
// //         }
// //     };






// //     useEffect(() => {
// //         const storedVendorId = localStorage.getItem("vendorId");
// //         setVendorId(storedVendorId);
// //     }, []);


// //     const [acceptedItems, setAcceptedItems] = useState({});

// //     const [selectedItems, setSelectedItems] = useState({});

// //     // Toggle checkbox
// //     const handleCheckboxChangea = (itemId) => {
// //         setSelectedItems((prev) => ({
// //             ...prev,
// //             [itemId]: !prev[itemId],
// //         }));
// //     };

// //     // Accept selected items
// //     const handleAcceptOrderrsss = async (e, cartId) => {
// //         e.stopPropagation();

// //         const status = "PROCESSING";
// //         const note = "sds";

// //         // ✅ Fetch token from localStorage
// //         const token = localStorage.getItem("authToken");

// //         if (!token) {
// //             console.error("🚨 Auth token not found in localStorage!");
// //             alert("You are not authorized. Please log in again.");
// //             return;
// //         }

// //         // ✅ Get array of selected itemIds
// //         const itemIds = Object.keys(selectedItems).filter((id) => selectedItems[id]);

// //         if (itemIds.length === 0) {
// //             alert("Please select at least one item to accept.");
// //             return;
// //         }

// //         // ✅ Build API URL properly with query params
// //         const url = `https://backend.maamaas.com/food/api/cart/cart/status/${cartId}?${itemIds
// //             .map((id) => `itemIds=${id}`)
// //             .join("&")}&status=${status}&note=${encodeURIComponent(note)}`;

// //         try {
// //             const response = await fetch(url, {
// //                 method: "PUT",
// //                 headers: {
// //                     "Content-Type": "application/json",
// //                     "Authorization": `Bearer ${token}`, // ✅ attach token
// //                 },
// //             });

// //             if (!response.ok) {
// //                 const errorText = await response.text();
// //                 throw new Error(`Error: ${response.status} - ${errorText}`);
// //             }

// //             const data = await response.json();
// //             // //console.log("✅ Status updated:", data);
// //             // alert("Items accepted successfully!");

// //             // ✅ Optional: clear selections
// //             setSelectedItems({});

// //         } catch (error) {
// //             console.error("❌ Failed to update status:", error);
// //             alert("Failed to update item status. Please try again.");
// //         }
// //     };




// //     const handleAcceptOrderr = async (e, orderId) => {
// //         e.stopPropagation();

// //         const token = localStorage.getItem("authToken"); // ✅ Retrieve token
// //         if (!token) {
// //             alert("Authentication token is missing.");
// //             return;
// //         }

// //         try {
// //             const response = await axios.put(
// //                 `https://backend.maamaas.com/food/api/orders/edit-orders/${orderId}/CONFIRMED`,
// //                 {
// //                     status: "CONFIRMED", // send in body
// //                 },
// //                 {
// //                     headers: {
// //                         Authorization: `Bearer ${token}`, // ✅ Add token to headers
// //                     },
// //                 }
// //             );

// //             // //console.log("Status updated:", response.data);

// //             // Update local UI
// //             setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
// //         } catch (error) {
// //             console.error("Failed to update order status:", error.response?.data || error.message);
// //         }
// //     };



// //     const handleAcceptOrderrs = async (e, itemId) => {
// //         e.stopPropagation();

// //         const status = "PROCESSING";
// //         const note = "sds"; // optional note
// //         const url = `https://backend.maamaas.com/food/api/cart/cartitem/status/${itemId}?status=${status}&note=${encodeURIComponent(note)}`;

// //         try {
// //             const response = await fetch(url, {
// //                 method: "PUT", // or POST depending on your API
// //                 headers: {
// //                     "Content-Type": "application/json",
// //                 },
// //             });

// //             if (!response.ok) {
// //                 throw new Error(`Error: ${response.status}`);
// //             }

// //             const data = await response.json();
// //             //console.log("✅ Status updated:", data);

// //             // Optional: update local state so UI reflects change
// //             // e.g., remove item from list or update its status
// //         } catch (error) {
// //             console.error("❌ Failed to update status:", error);
// //         }
// //     };

// //     const handleAcceptOrderrss = async (e, itemId) => {
// //         e.stopPropagation();

// //         const status = "CANCELLED";
// //         const note = "sds"; // optional note 
// //         const url = `https://backend.maamaas.com/food/api/cart/cartitem/status/${itemId}?status=${status}&note=${encodeURIComponent(note)}`;

// //         try {
// //             const response = await fetch(url, {
// //                 method: "PUT", // or POST depending on your API
// //                 headers: {
// //                     "Content-Type": "application/json",
// //                 },
// //             });

// //             if (!response.ok) {
// //                 throw new Error(`Error: ${response.status}`);
// //             }

// //             const data = await response.json();
// //             //console.log("✅ Status updated:", data);

// //             // Optional: update local state so UI reflects change
// //             // e.g., remove item from list or update its status
// //         } catch (error) {
// //             console.error("❌ Failed to update status:", error);
// //         }
// //     };
// //     useEffect(() => {
// //         if (!vendorId) return;

// //         const fetchOrders = async () => {
// //             const token = localStorage.getItem("authToken");
// //             if (!token) return;

// //             try {
// //                 // 1️⃣ Fetch vendor orders
// //                 const vendorRes = await axios.get(
// //                     `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
// //                     { headers: { Authorization: `Bearer ${token}` } }
// //                 );

// //                 const vendorOrders = vendorRes.data || [];
// //                 //console.log("mobile response data ", vendorOrders)
// //                 // Filter out dine-in pending
// //                 const filteredVendorOrders = vendorOrders.filter(
// //                     (order) => !(order.orderType === "TABLE_DINE_IN" && order.status === "PENDING")
// //                 );

// //                 // Separate pending and confirmed
// //                 const pendingOrders = filteredVendorOrders.filter(
// //                     (order) => order.status === "PENDING"
// //                 );

// //                 const confirmedOrdersFromVendor = vendorOrders.filter(
// //                     (order) =>
// //                         Array.isArray(order.cartItems) &&
// //                         order.cartItems.some((item) => item.orderStatus === "CONFIRMED")
// //                 );

// //                 // 2️⃣ Fetch dine-in orders by status
// //                 const statuses = ["PENDING", "CONFIRMED"];
// //                 const dineInPromises = statuses.map((status) =>
// //                     axios.get(
// //                         `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/${status}`,
// //                         { headers: { Authorization: `Bearer ${token}` } }
// //                     )
// //                 );

// //                 const dineInResponses = await Promise.all(dineInPromises);
// //                 const dineInOrders = dineInResponses.flatMap((res) => res.data || []);

// //                 // 3️⃣ Merge everything
// //                 const allOrders = [...pendingOrders, ...confirmedOrdersFromVendor, ...dineInOrders];

// //                 // 4️⃣ Deduplicate by cartId or orderId
// //                 const uniqueOrders = allOrders.filter(
// //                     (order, index, self) =>
// //                         index ===
// //                         self.findIndex(
// //                             (o) =>
// //                                 (o.cartId && o.cartId === order.cartId) ||
// //                                 (o.orderId && o.orderId === order.orderId)
// //                         )
// //                 );

// //                 // 5️⃣ Notify on new orders
// //                 const previousOrdersIds = orders.map((o) => o.orderId || o.cartId);
// //                 const newOrders = uniqueOrders.filter(
// //                     (o) => !previousOrdersIds.includes(o.orderId || o.cartId)
// //                 );

// //                 if (newOrders.length > 0) {
// //                     notificationSound.play().catch((e) => console.warn("Autoplay prevented:", e));
// //                 }

// //                 setOrders(uniqueOrders);
// //             } catch (error) {
// //                 console.error("Error fetching orders:", error.response?.data || error.message);
// //             }
// //         };

// //         fetchOrders();
// //     }, [vendorId]);


// //     // Horizontal Auto-scroll
// //     useEffect(() => {
// //         const scrollContainer = scrollContainerRef.current;
// //         if (!scrollContainer) return;

// //         let interval = setInterval(() => {
// //             if (!isHovered) {
// //                 scrollContainer.scrollLeft += 1;
// //                 if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
// //                     scrollContainer.scrollLeft = 0;
// //                 }
// //             }
// //         }, 20);

// //         return () => clearInterval(interval);
// //     }, [isHovered]);

// //     const getOrderColor = (orderType) => {
// //         const normalized = (orderType || "").trim().toLowerCase();
// //         switch (normalized) {
// //             case "dine_in":
// //                 return "#1E90FF";
// //             case "takeaway":
// //                 return "#FF6347";
// //             case "delivery":
// //                 return "#20B2AA";
// //             case "table_dine_in":
// //                 return "#2051b2ff";
// //             default:
// //                 return "#ccc";
// //         }
// //     };



// //     const handleAcceptOrder = async (e, orderId) => {
// //         e.stopPropagation();
// //         const token = localStorage.getItem("authToken");
// //         if (!token) return;

// //         try {
// //             await axios.put(
// //                 `https://backend.maamaas.com/food/orders/editstatus/${orderId}`,
// //                 { orderStatus: "CONFIRMED" },
// //                 { headers: { Authorization: `Bearer ${token}` } }
// //             );
// //             setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
// //         } catch (error) {
// //             console.error("Accept error:", error.response?.data || error.message);
// //         }
// //     };

// //     const handleDeclineOrder = async (e, orderId) => {
// //         e.stopPropagation();

// //         const token = localStorage.getItem("authToken");
// //         if (!token) {
// //             alert("Authentication token is missing.");
// //             return;
// //         }

// //         try {
// //             const response = await axios.put(
// //                 `https://backend.maamaas.com/food/api/orders/cancal/total/order/${orderId}`,
// //                 {}, // ✅ Empty body (if your API doesn’t need one)
// //                 {
// //                     headers: {
// //                         Authorization: `Bearer ${token}`, // ✅ Correct placement
// //                         "Content-Type": "application/json",
// //                     },
// //                 }
// //             );

// //             // //console.log("✅ Status updated:", response.data);

// //             // ✅ Update UI after successful cancellation
// //             setOrders((prev) => prev.filter((order) => order.orderId !== orderId));

// //         } catch (error) {
// //             console.error(
// //                 "❌ Failed to update order status:",
// //                 error.response?.data || error.message
// //             );

// //             if (error.response?.status === 403) {
// //                 alert("Access denied. Your session may have expired — please log in again.");
// //             }
// //         }
// //     };

// //     return (
// //         <div>
// //             {/* Internal CSS */}
// //             <style>
// //                 {`
// //                 @media (min-width: 768px) {
// //                 .order-card{
// //                 display:none !important;
// //                 }
               
// //                 }

             
// //         @media (max-width: 768px) {
        
// //           .mobile-orders-wrapper {
// //             width: 100%;
// //             left: 0;
// //             right: 0;
        
// //             top: 0px;
// //             height: auto;
      
// //             padding: 10px;
// //             border-radius: 0;
// //           }

// //          /* Inside your <style> tag */
// // .mobile-scroll-container {
// //   display: flex;
// //   flex-direction: row;
// //   overflow-x: auto;
// //   gap: 12px;
// //   padding-bottom: 10px;
// //   scroll-behavior: smooth;
// //   margin-top: 60px;
// //   background:#fff;
// //   -ms-overflow-style: none; /* IE */
// //   scrollbar-width: none; /* Firefox */
// // }

// // .order-card {
// //   flex-shrink: 0;
// //   width: 280px;          /* ✅ Fixed width for consistency */
// //   max-width: 90vw;     /* ✅ Keeps consistent height */
// //   border-radius: 10px;
// //   box-shadow: 0px 3px 6px rgba(0,0,0,0.15);
// //   padding: 12px;
// //   transition: all 0.3s ease-in-out;
// // }

// //         }

// //         .hide-scrollbar {
// //           -ms-overflow-style: none;
// //           scrollbar-width: none;
// //         }

// //         .hide-scrollbar::-webkit-scrollbar {
// //           display: none;
// //         }
// //         `}
// //             </style>

// //             <div
// //                 className="mobile-orders-wrapper"
// //                 style={{
// //                     position: "fixed",

// //                     right: "16px",
// //                     borderRadius: "8px",
// //                     padding: "10px",
// //                     marginTop: "40px",
// //                 }}
// //             >
// //                 <div
// //                     className="hide-scrollbar"
// //                     style={{
// //                         maxHeight: "600px",
// //                         overflowY: "auto",
// //                         paddingRight: "5px",
// //                         // marginTop: "30px",
// //                     }}
// //                     onMouseEnter={() => setIsHovered(true)}
// //                     onMouseLeave={() => setIsHovered(false)}
// //                 >
// //                     <div className="mobile-scroll-container" ref={scrollContainerRef}>
// //                         {orders.map((order, index) => {
// //                             const uniqueId = order.orderId || order.cartId;
// //                             const itemsList = order.items || order.order || order.cartItems || [];

// //                             const isExpanded =
// //                                 expandedOrder &&
// //                                 (expandedOrder.orderId === uniqueId || expandedOrder.cartId === uniqueId);

// //                             return (
// //                                 <div
// //                                     key={`${uniqueId}-${index}`}
// //                                     onClick={() => handleOrderClick(order)}
// //                                     className="order-card scroll-data-responsive"
// //                                     style={{
// //                                         cursor: "pointer",
// //                                         background: getOrderColor(order.orderType),
// //                                         position: "relative",
// //                                         height: isExpanded ? "auto" : "auto",
// //                                     }}
// //                                 >

// //                                     <div style={{ width: "100%" }}>
// //                                         {/* Header */}
// //                                         <div
// //                                             style={{
// //                                                 display: "flex",
// //                                                 justifyContent: "space-between",
// //                                                 alignItems: "center",
// //                                                 color: "#fff",
// //                                                 fontWeight: "bold",
// //                                             }}
// //                                         >
// //                                             <div style={{ display: "flex" }}>
// //                                                 <div
// //                                                     style={{

// //                                                         color: "rgba(255, 255, 255, 0.9)",
// //                                                         marginRight: "10px",
// //                                                         fontSize: "18px",
// //                                                         transition: "transform 0.3s ease",
// //                                                         transform: expandedOrder?.orderId === order.orderId ? "rotate(180deg)" : "rotate(0deg)",
// //                                                         // Add this line:
// //                                                     }}
// //                                                 >
// //                                                     ▼
// //                                                 </div>

// //                                                 Order ID: #{uniqueId}
// //                                             </div>
// //                                             <h5 style={{ marginTop: "0px" }}> {order.orderType === "DINE_IN" ? "DINEIN" : order.orderType || "N/A"}</h5>
// //                                         </div>




// //                                         {isExpanded && (
// //                                             <div style={{ marginTop: "-10px" }}>
// //                                                 {/* Headers for items list */}
// //                                                 <div style={{
// //                                                     display: 'flex',
// //                                                     justifyContent: 'space-between',
// //                                                     alignItems: 'center',
// //                                                     padding: '8px 10px',
// //                                                     borderRadius: '4px',
// //                                                     marginBottom: '0px',
// //                                                     fontWeight: 'bold',
// //                                                     fontSize: '16px',
// //                                                     color: '#fff'
// //                                                 }}>
// //                                                     <div style={{ flex: 0, textAlign: 'left' }}>Items</div>
// //                                                     <div style={{ flex: 1, textAlign: 'center' }}>Quantity</div>
// //                                                 </div>

// //                                                 {order.orderType === "TABLE_DINE_IN" && (
// //                                                     <ul
// //                                                         style={{ listStyle: "none", padding: 0, marginLeft: "10px", fontWeight: "bold" }}
// //                                                         onClick={(e) => e.stopPropagation()}
// //                                                     >
// //                                                         {itemsList.map((item, idx) => (
// //                                                             <li
// //                                                                 key={idx}
// //                                                                 style={{
// //                                                                     display: "flex",
// //                                                                     justifyContent: "space-between",
// //                                                                     alignItems: "center",
// //                                                                     color: "#000",
// //                                                                     fontSize: "14px",
// //                                                                     marginBottom: "3px",
// //                                                                     padding: "0px 10px 8px 10px",
// //                                                                     borderRadius: '4px'
// //                                                                 }}
// //                                                             >
// //                                                                 <div style={{ display: "flex", alignItems: "center", gap: "10px", flex: 2 }}>
// //                                                                     <input
// //                                                                         type="checkbox"
// //                                                                         checked={!!selectedItems[item.itemId]}
// //                                                                         onChange={(e) => {
// //                                                                             e.stopPropagation();
// //                                                                             handleCheckboxChangea(item.itemId);
// //                                                                         }}
// //                                                                     />
// //                                                                     <span style={{ fontWeight: "600" }}>
// //                                                                         {item.dishName || "Unnamed Dish"}
// //                                                                     </span>
// //                                                                 </div>
// //                                                                 <div style={{ flex: 1, textAlign: 'start' }}>
// //                                                                     × {item.updateQuantity ?? 0}
// //                                                                 </div>
// //                                                             </li>
// //                                                         ))}
// //                                                     </ul>
// //                                                 )}

// //                                                 {/* Non-TABLE_DINE_IN items */}
// //                                                 <ul style={{ listStyle: "none", padding: 0, marginLeft: "10px", fontWeight: "bold" }}>
// //                                                     {itemsList
// //                                                         .filter((item) => item.status === "Okay")
// //                                                         .map((item, idx) => (
// //                                                             <li
// //                                                                 key={idx}
// //                                                                 style={{
// //                                                                     color: "#000",
// //                                                                     fontSize: "14px",
// //                                                                     marginBottom: "3px",
// //                                                                     display: "flex",
// //                                                                     justifyContent: "space-between",
// //                                                                     alignItems: "center",
// //                                                                     padding: "0px 10px8px 10px",
// //                                                                     borderRadius: '4px'
// //                                                                 }}
// //                                                                 onClick={(e) => e.stopPropagation()}
// //                                                             >
// //                                                                 <div style={{ display: "flex", alignItems: "center", gap: "8px", flex: 2 }}>
// //                                                                     <input
// //                                                                         type="checkbox"
// //                                                                         checked={!!checkedItems[item.listId]}
// //                                                                         onChange={() => handleCheckboxChange(item.listId)}
// //                                                                     />
// //                                                                     <span>{item.dishName}</span>
// //                                                                 </div>
// //                                                                 <div style={{ flex: 1, textAlign: 'start' }}>
// //                                                                     × {item.quantity}
// //                                                                 </div>
// //                                                                 <div style={{ flex: 1, textAlign: 'right' }}>
// //                                                                     <button
// //                                                                         onClick={() => handleCancelSingleOrder(item.listId)}
// //                                                                         style={{
// //                                                                             padding: "4px 8px",
// //                                                                             backgroundColor: "rgb(220, 53, 69)",
// //                                                                             color: "white",
// //                                                                             fontSize: "12px",
// //                                                                             fontWeight: "bold",
// //                                                                             border: "none",
// //                                                                             borderRadius: "5px",
// //                                                                             cursor: "pointer",
// //                                                                         }}
// //                                                                     >
// //                                                                         Cancel
// //                                                                     </button>
// //                                                                 </div>
// //                                                             </li>
// //                                                         ))}
// //                                                 </ul>
// //                                             </div>
// //                                         )}



// //                                         {order.orderType === "TABLE_DINE_IN" && (
// //                                             <div
// //                                                 style={{
// //                                                     display: "flex",
// //                                                     justifyContent: "space-between",
// //                                                     marginTop: "10px",
// //                                                 }}
// //                                             >
// //                                                 <button
// //                                                     onClick={(e) => handleAcceptOrderrsss(e, order.cartId)}
// //                                                     style={{
// //                                                         padding: "8px",
// //                                                         backgroundColor: "rgb(177 93 198)",
// //                                                         color: "white",
// //                                                         fontSize: "14px",
// //                                                         fontWeight: "bold",
// //                                                         border: "none",
// //                                                         borderRadius: "5px",
// //                                                         cursor: "pointer",
// //                                                     }}
// //                                                 >
// //                                                     Accept
// //                                                 </button>
// //                                                 <button
// //                                                     onClick={(e) => {
// //                                                         e.stopPropagation();
// //                                                         handleAcceptOrderrss(e, order.cartId); // ✅ using cartId instead of itemId
// //                                                     }}
// //                                                     style={{
// //                                                         padding: "8px",
// //                                                         backgroundColor: "rgb(177 93 198)",
// //                                                         color: "white",
// //                                                         fontSize: "14px",
// //                                                         fontWeight: "bold",
// //                                                         border: "none",
// //                                                         borderRadius: "5px",
// //                                                         cursor: "pointer",
// //                                                     }}
// //                                                 >
// //                                                     Decline
// //                                                 </button>
// //                                             </div>
// //                                         )}




// //                                         {/* Buttons for non-TABLE_DINE_IN orders */}
// //                                         {order.orderType !== "TABLE_DINE_IN" && (
// //                                             <div
// //                                                 style={{
// //                                                     display: "flex",
// //                                                     justifyContent: "space-between",
// //                                                     marginTop: "10px",
// //                                                 }}
// //                                             >
// //                                                 <button
// //                                                     onClick={(e) => handleAcceptOrderr(e, uniqueId)}
// //                                                     style={{
// //                                                         padding: "8px",
// //                                                         backgroundColor: "rgb(177 93 198)",
// //                                                         color: "white",
// //                                                         fontSize: "14px",
// //                                                         fontWeight: "bold",
// //                                                         border: "none",
// //                                                         borderRadius: "5px",
// //                                                         cursor: "pointer",
// //                                                     }}
// //                                                 >
// //                                                     Accept
// //                                                 </button>
// //                                                 <button
// //                                                     onClick={(e) => handleDeclineOrder(e, uniqueId)}
// //                                                     style={{
// //                                                         padding: "8px",
// //                                                         backgroundColor: "rgb(177 93 198)",
// //                                                         color: "white",
// //                                                         fontSize: "14px",
// //                                                         fontWeight: "bold",
// //                                                         border: "none",
// //                                                         borderRadius: "5px",
// //                                                         cursor: "pointer",
// //                                                     }}
// //                                                 >
// //                                                     Decline
// //                                                 </button>
// //                                             </div>
// //                                         )}
// //                                     </div>
// //                                 </div>
// //                             );
// //                         })}
// //                     </div>
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // };

// // export default MobileOrderspage;




// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import sound from "../../../../images/alaram.mp3";

// const MobileOrderspage = () => {
//     const [isHovered, setIsHovered] = useState(false);
//     const [expandedOrder, setExpandedOrder] = useState(null);
//     const [orders, setOrders] = useState([]);
//     const [checkedItems, setCheckedItems] = useState({});
//     const [vendorId, setVendorId] = useState(null);
//     const scrollContainerRef = useRef(null);
//     const notificationSound = new Audio(sound);
//     const [loading, setLoading] = useState(true); // track loading state
    

//     useEffect(() => {
//         const storedVendorId = localStorage.getItem("vendorId");
//         setVendorId(storedVendorId);
//     }, []);

//     const handleCheckboxChange = (listId) => {
//         setCheckedItems((prev) => ({
//             ...prev,
//             [listId]: !prev[listId],
//         }));
//         //console.log("Selected List ID:", listId);
//     };


//     const handleCancelSingleOrder = async (listId) => {
//         try {
//             const token = localStorage.getItem("authToken"); // ✅ Adjust key name if needed

//             if (!token) {
//                 alert("Authorization token not found!");
//                 return;
//             }

//             const response = await fetch(
//                 `https://backend.maamaas.com/food/orderscancellationlist/edit/${listId}`,
//                 {
//                     method: "PUT",
//                     headers: {
//                         "Content-Type": "application/json",
//                         "Authorization": `Bearer ${token}`, // 👈 Add token here
//                     },
//                     body: JSON.stringify({
//                         status: "Cancelled",
//                     }),
//                 }
//             );

//             if (!response.ok) {
//                 console.error(`Failed to cancel order ${listId}`);
//                 alert(`Failed to cancel order ${listId}`);
//             } else {
//                 //console.log(`Order ${listId} cancelled successfully.`);
//                 alert(`Order ${listId} has been cancelled.`);
//                 // Optional: Uncheck after cancellation
//                 setCheckedItems((prev) => {
//                     const updated = { ...prev };
//                     delete updated[listId];
//                     return updated;
//                 });
//             }
//         } catch (error) {
//             console.error("Error cancelling order:", error);
//         }
//     };


//     const handleOrderClick = (order) => {
//         const id = order.orderId || order.cartId; // normalize ID
//         //console.log("Clicked order:", order); // ✅ debug

//         if (expandedOrder && expandedOrder.id === id) {
//             //console.log("Collapsing order:", id);
//             setExpandedOrder(null); // collapse
//         } else {
//             //console.log("Expanding order:", id);
//             setExpandedOrder({ ...order, id }); // expand
//         }
//     };






//     useEffect(() => {
//         const storedVendorId = localStorage.getItem("vendorId");
//         setVendorId(storedVendorId);
//     }, []);


//     const [acceptedItems, setAcceptedItems] = useState({});

//     const [selectedItems, setSelectedItems] = useState({});

//     // Toggle checkbox
//     const handleCheckboxChangea = (itemId) => {
//         setSelectedItems((prev) => ({
//             ...prev,
//             [itemId]: !prev[itemId],
//         }));
//     };

//     // Accept selected items
//     const handleAcceptOrderrsss = async (e, cartId) => {
//         e.stopPropagation();

//         const status = "PROCESSING";
//         const note = "sds";

//         // ✅ Fetch token from localStorage
//         const token = localStorage.getItem("authToken");

//         if (!token) {
//             console.error("🚨 Auth token not found in localStorage!");
//             alert("You are not authorized. Please log in again.");
//             return;
//         }

//         // ✅ Get array of selected itemIds
//         const itemIds = Object.keys(selectedItems).filter((id) => selectedItems[id]);

//         if (itemIds.length === 0) {
//             alert("Please select at least one item to accept.");
//             return;
//         }

//         // ✅ Build API URL properly with query params
//         const url = `https://backend.maamaas.com/food/api/cart/cart/status/${cartId}?${itemIds
//             .map((id) => `itemIds=${id}`)
//             .join("&")}&status=${status}&note=${encodeURIComponent(note)}`;

//         try {
//             const response = await fetch(url, {
//                 method: "PUT",
//                 headers: {
//                     "Content-Type": "application/json",
//                     "Authorization": `Bearer ${token}`, // ✅ attach token
//                 },
//             });

//             if (!response.ok) {
//                 const errorText = await response.text();
//                 throw new Error(`Error: ${response.status} - ${errorText}`);
//             }

//             const data = await response.json();
//             // //console.log("✅ Status updated:", data);
//             // alert("Items accepted successfully!");

//             // ✅ Optional: clear selections
//             setSelectedItems({});

//         } catch (error) {
//             console.error("❌ Failed to update status:", error);
//             alert("Failed to update item status. Please try again.");
//         }
//     };




//     const handleAcceptOrderr = async (e, orderId) => {
//         e.stopPropagation();

//         const token = localStorage.getItem("authToken"); // ✅ Retrieve token
//         if (!token) {
//             alert("Authentication token is missing.");
//             return;
//         }

//         try {
//             const response = await axios.put(
//                 `https://backend.maamaas.com/food/api/orders/edit-orders/${orderId}/CONFIRMED`,
//                 {
//                     status: "CONFIRMED", // send in body
//                 },
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`, // ✅ Add token to headers
//                     },
//                 }
//             );

//             // //console.log("Status updated:", response.data);

//             // Update local UI
//             setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
//         } catch (error) {
//             console.error("Failed to update order status:", error.response?.data || error.message);
//         }
//     };



//     const handleAcceptOrderrs = async (e, itemId) => {
//         e.stopPropagation();

//         const status = "PROCESSING";
//         const note = "sds"; // optional note
//         const url = `https://backend.maamaas.com/food/api/cart/cartitem/status/${itemId}?status=${status}&note=${encodeURIComponent(note)}`;

//         try {
//             const response = await fetch(url, {
//                 method: "PUT", // or POST depending on your API
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//             });

//             if (!response.ok) {
//                 throw new Error(`Error: ${response.status}`);
//             }

//             const data = await response.json();
//             //console.log("✅ Status updated:", data);

//             // Optional: update local state so UI reflects change
//             // e.g., remove item from list or update its status
//         } catch (error) {
//             console.error("❌ Failed to update status:", error);
//         }
//     };

//     const handleAcceptOrderrss = async (e, itemId) => {
//         e.stopPropagation();

//         const status = "CANCELLED";
//         const note = "sds"; // optional note 
//         const url = `https://backend.maamaas.com/food/api/cart/cartitem/status/${itemId}?status=${status}&note=${encodeURIComponent(note)}`;

//         try {
//             const response = await fetch(url, {
//                 method: "PUT", // or POST depending on your API
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//             });

//             if (!response.ok) {
//                 throw new Error(`Error: ${response.status}`);
//             }

//             const data = await response.json();
//             //console.log("✅ Status updated:", data);

//             // Optional: update local state so UI reflects change
//             // e.g., remove item from list or update its status
//         } catch (error) {
//             console.error("❌ Failed to update status:", error);
//         }
//     };
//     useEffect(() => {
//         if (!vendorId) return;

//         // const fetchOrders = async () => {
//         //     const token = localStorage.getItem("authToken");
//         //     if (!token) return;

//         //     try {
//         //         // 1️⃣ Fetch vendor orders
//         //         const vendorRes = await axios.get(
//         //             `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
//         //             { headers: { Authorization: `Bearer ${token}` } }
//         //         );

//         //         const vendorOrders = vendorRes.data || [];
//         //         //console.log("mobile response data ", vendorOrders)
//         //         // Filter out dine-in pending
//         //         const filteredVendorOrders = vendorOrders.filter(
//         //             (order) => !(order.orderType === "TABLE_DINE_IN" && order.status === "PENDING")
//         //         );

//         //         // Separate pending and confirmed
//         //         const pendingOrders = filteredVendorOrders.filter(
//         //             (order) => order.status === "PENDING"
//         //         );

//         //         const confirmedOrdersFromVendor = vendorOrders.filter(
//         //             (order) =>
//         //                 Array.isArray(order.cartItems) &&
//         //                 order.cartItems.some((item) => item.orderStatus === "CONFIRMED")
//         //         );

//         //         // 2️⃣ Fetch dine-in orders by status
//         //         const statuses = ["PENDING", "CONFIRMED"];
//         //         const dineInPromises = statuses.map((status) =>
//         //             axios.get(
//         //                 `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/${status}`,
//         //                 { headers: { Authorization: `Bearer ${token}` } }
//         //             )
//         //         );

//         //         const dineInResponses = await Promise.all(dineInPromises);
//         //         const dineInOrders = dineInResponses.flatMap((res) => res.data || []);

//         //         // 3️⃣ Merge everything
//         //         const allOrders = [...pendingOrders, ...confirmedOrdersFromVendor, ...dineInOrders];

//         //         // 4️⃣ Deduplicate by cartId or orderId
//         //         const uniqueOrders = allOrders.filter(
//         //             (order, index, self) =>
//         //                 index ===
//         //                 self.findIndex(
//         //                     (o) =>
//         //                         (o.cartId && o.cartId === order.cartId) ||
//         //                         (o.orderId && o.orderId === order.orderId)
//         //                 )
//         //         );

//         //         // 5️⃣ Notify on new orders
//         //         const previousOrdersIds = orders.map((o) => o.orderId || o.cartId);
//         //         const newOrders = uniqueOrders.filter(
//         //             (o) => !previousOrdersIds.includes(o.orderId || o.cartId)
//         //         );

//         //         if (newOrders.length > 0) {
//         //             notificationSound.play().catch((e) => console.warn("Autoplay prevented:", e));
//         //         }

//         //         setOrders(uniqueOrders);
//         //     } catch (error) {
//         //         console.error("Error fetching orders:", error.response?.data || error.message);
//         //     }
//         // };


//         const fetchOrders = async () => {
//             if (!vendorId) return;

//             const token = localStorage.getItem("authToken");
//             if (!token) return;

//             try {
//                 const vendorRes = await axios.get(
//                     `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
//                     { headers: { Authorization: `Bearer ${token}` } }
//                 );

//                 // Filter to show orders that are BOTH PENDING AND Online_Payment
//                 const filteredVendorOrders = vendorRes.data.filter(
//                     (order) => {
//                         // Condition 1: Don't show TABLE_DINE_IN with PENDING status
//                         const isTableDineInPending = order.orderType === "TABLE_DINE_IN" && order.status === "PENDING";

//                         // Condition 2: Show orders that are BOTH PENDING AND Online_Payment
//                         const showOrder = order.status === "PENDING" &&
//                             (order.paymentMethod === "Online_Payment" ||
//                                 order.paymentMethod === "ONLINE_PAYMENT"); // Handle case variations

//                         return !isTableDineInPending && showOrder;
//                     }
//                 );

//                 // Get pending online orders specifically
//                 const pendingOnlineOrders = vendorRes.data.filter(
//                     (order) => order.status === "PENDING" &&
//                         (order.paymentMethod === "Online_Payment" ||
//                             order.paymentMethod === "ONLINE_PAYMENT")
//                 );

//                 const confirmedOrdersFromVendor = vendorRes.data.filter(
//                     (order) =>
//                         Array.isArray(order.cartItems) &&
//                         order.cartItems.some((item) => item.orderStatus === "CONFIRMED")
//                 );

//                 // Fetch TABLE_DINE_IN orders
//                 const statuses = ["PENDING", "CONFIRMED"];
//                 const dineInPromises = statuses.map((status) =>
//                     axios.get(
//                         `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/${status}`,
//                         { headers: { Authorization: `Bearer ${token}` } }
//                     )
//                 );

//                 const dineInResponses = await Promise.all(dineInPromises);
//                 const dineInOrders = dineInResponses.flatMap((res) => res.data || []);

//                 // Filter TABLE_DINE_IN orders for PENDING AND Online_Payment
//                 const filteredDineInOrders = dineInOrders.filter(
//                     (order) => order.status === "PENDING" &&
//                         (order.paymentMethod === "Online_Payment" ||
//                             order.paymentMethod === "ONLINE_PAYMENT")
//                 );

//                 // Merge all results - only orders that are PENDING AND Online_Payment
//                 const allOrders = [...filteredVendorOrders, ...filteredDineInOrders];

//                 // For confirmed orders, include them as before
//                 const allOrdersWithConfirmed = [...allOrders, ...confirmedOrdersFromVendor];

//                 // Deduplicate
//                 const uniqueOrders = allOrdersWithConfirmed.filter(
//                     (order, index, self) =>
//                         index ===
//                         self.findIndex(
//                             (o) =>
//                                 (o.cartId && o.cartId === order.cartId) ||
//                                 (o.orderId && o.orderId === order.orderId)
//                         )
//                 );

//                 // 🔔 Check for new orders
//                 const previousOrdersIds = orders.map((o) => o.orderId || o.cartId);
//                 const newOrders = uniqueOrders.filter(
//                     (o) => !previousOrdersIds.includes(o.orderId || o.cartId)
//                 );

//                 if (newOrders.length > 0) {
//                     notificationSound.play().catch((e) => console.warn("Autoplay prevented:", e));
//                 }

//                 setOrders(uniqueOrders);
//             } catch (error) {
//                 console.error("Error fetching orders:", error.response?.data || error.message);
//             }
//             finally {
//                 setLoading(false); // stop loader
//             }
//         };
//         fetchOrders();
//     }, [vendorId]);


//     // Horizontal Auto-scroll
//     useEffect(() => {
//         const scrollContainer = scrollContainerRef.current;
//         if (!scrollContainer) return;

//         let interval = setInterval(() => {
//             if (!isHovered) {
//                 scrollContainer.scrollLeft += 1;
//                 if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
//                     scrollContainer.scrollLeft = 0;
//                 }
//             }
//         }, 20);

//         return () => clearInterval(interval);
//     }, [isHovered]);

//     const getOrderColor = (orderType) => {
//         const normalized = (orderType || "").trim().toLowerCase();
//         switch (normalized) {
//             case "dine_in":
//                 return "#1E90FF";
//             case "takeaway":
//                 return "#FF6347";
//             case "delivery":
//                 return "#20B2AA";
//             case "table_dine_in":
//                 return "#2051b2ff";
//             default:
//                 return "#ccc";
//         }
//     };



//     const handleAcceptOrder = async (e, orderId) => {
//         e.stopPropagation();
//         const token = localStorage.getItem("authToken");
//         if (!token) return;

//         try {
//             await axios.put(
//                 `https://backend.maamaas.com/food/orders/editstatus/${orderId}`,
//                 { orderStatus: "CONFIRMED" },
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );
//             setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
//         } catch (error) {
//             console.error("Accept error:", error.response?.data || error.message);
//         }
//     };

//     const handleDeclineOrder = async (e, orderId) => {
//         e.stopPropagation();

//         const token = localStorage.getItem("authToken");
//         if (!token) {
//             alert("Authentication token is missing.");
//             return;
//         }

//         try {
//             const response = await axios.put(
//                 `https://backend.maamaas.com/food/api/orders/cancal/total/order/${orderId}`,
//                 {}, // ✅ Empty body (if your API doesn’t need one)
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`, // ✅ Correct placement
//                         "Content-Type": "application/json",
//                     },
//                 }
//             );

//             // //console.log("✅ Status updated:", response.data);

//             // ✅ Update UI after successful cancellation
//             setOrders((prev) => prev.filter((order) => order.orderId !== orderId));

//         } catch (error) {
//             console.error(
//                 "❌ Failed to update order status:",
//                 error.response?.data || error.message
//             );

//             if (error.response?.status === 403) {
//                 alert("Access denied. Your session may have expired — please log in again.");
//             }
//         }
//     };

//     return (
//         <div>
//             {/* Internal CSS */}
//             <style>
//                 {`
//                 @media (min-width: 768px) {
//                 .order-card{
//                 display:none !important;
//                 }
               
//                 }

             
//         @media (max-width: 768px) {
        
//           .mobile-orders-wrapper {
//             width: 100%;
//             left: 0;
//             right: 0;
        
//             top: 0px;
//             height: auto;
      
//             padding: 10px;
//             border-radius: 0;
//           }

//          /* Inside your <style> tag */
// .mobile-scroll-container {
//   display: flex;
//   flex-direction: row;
//   overflow-x: auto;
//   gap: 12px;
//   padding-bottom: 10px;
//   scroll-behavior: smooth;
//   margin-top: 60px;
//   background:#fff;
//   -ms-overflow-style: none; /* IE */
//   scrollbar-width: none; /* Firefox */
// }

// .order-card {
//   flex-shrink: 0;
//   width: 280px;          /* ✅ Fixed width for consistency */
//   max-width: 90vw;     /* ✅ Keeps consistent height */
//   border-radius: 10px;
//   box-shadow: 0px 3px 6px rgba(0,0,0,0.15);
//   padding: 12px;
//   transition: all 0.3s ease-in-out;
// }

//         }

//         .hide-scrollbar {
//           -ms-overflow-style: none;
//           scrollbar-width: none;
//         }

//         .hide-scrollbar::-webkit-scrollbar {
//           display: none;
//         }
//         `}
//             </style>

//             <div
//                 className="mobile-orders-wrapper"
//                 style={{
//                     position: "fixed",

//                     right: "16px",
//                     borderRadius: "8px",
//                     padding: "10px",
//                     marginTop: "40px",
//                 }}
//             >
//                 <div
//                     className="hide-scrollbar"
//                     style={{
//                         maxHeight: "600px",
//                         overflowY: "auto",
//                         paddingRight: "5px",
//                         // marginTop: "30px",
//                     }}
//                     onMouseEnter={() => setIsHovered(true)}
//                     onMouseLeave={() => setIsHovered(false)}
//                 >
//                     <div className="mobile-scroll-container" ref={scrollContainerRef}>
//                         {orders.map((order, index) => {
//                             const uniqueId = order.orderId || order.cartId;
//                             const itemsList = order.items || order.order || order.cartItems || [];

//                             const isExpanded =
//                                 expandedOrder &&
//                                 (expandedOrder.orderId === uniqueId || expandedOrder.cartId === uniqueId);

//                             return (
//                                 <div
//                                     key={`${uniqueId}-${index}`}
//                                     onClick={() => handleOrderClick(order)}
//                                     className="order-card scroll-data-responsive"
//                                     style={{
//                                         cursor: "pointer",
//                                         background: getOrderColor(order.orderType),
//                                         position: "relative",
//                                         height: isExpanded ? "auto" : "auto",
//                                     }}
//                                 >

//                                     <div style={{ width: "100%" }}>
//                                         {/* Header */}
//                                         <div
//                                             style={{
//                                                 display: "flex",
//                                                 justifyContent: "space-between",
//                                                 alignItems: "center",
//                                                 color: "#fff",
//                                                 fontWeight: "bold",
//                                             }}
//                                         >
//                                             <div style={{ display: "flex" }}>
//                                                 <div
//                                                     style={{

//                                                         color: "rgba(255, 255, 255, 0.9)",
//                                                         marginRight: "10px",
//                                                         fontSize: "18px",
//                                                         transition: "transform 0.3s ease",
//                                                         transform: expandedOrder?.orderId === order.orderId ? "rotate(180deg)" : "rotate(0deg)",
//                                                         // Add this line:
//                                                     }}
//                                                 >
//                                                     ▼
//                                                 </div>

//                                                 Order ID: #{uniqueId}
//                                             </div>
//                                             <h5 style={{ marginTop: "0px" }}> {order.orderType === "DINE_IN" ? "DINEIN" : order.orderType || "N/A"}</h5>
//                                         </div>




//                                         {isExpanded && (
//                                             <div style={{ marginTop: "-10px" }}>
//                                                 {/* Headers for items list */}
//                                                 <div style={{
//                                                     display: 'flex',
//                                                     justifyContent: 'space-between',
//                                                     alignItems: 'center',
//                                                     padding: '8px 10px',
//                                                     borderRadius: '4px',
//                                                     marginBottom: '0px',
//                                                     fontWeight: 'bold',
//                                                     fontSize: '16px',
//                                                     color: '#fff'
//                                                 }}>
//                                                     <div style={{ flex: 0, textAlign: 'left' }}>Items</div>
//                                                     <div style={{ flex: 1, textAlign: 'center' }}>Quantity</div>
//                                                 </div>

//                                                 {order.orderType === "TABLE_DINE_IN" && (
//                                                     <ul
//                                                         style={{ listStyle: "none", padding: 0, marginLeft: "10px", fontWeight: "bold" }}
//                                                         onClick={(e) => e.stopPropagation()}
//                                                     >
//                                                         {itemsList.map((item, idx) => (
//                                                             <li
//                                                                 key={idx}
//                                                                 style={{
//                                                                     display: "flex",
//                                                                     justifyContent: "space-between",
//                                                                     alignItems: "center",
//                                                                     color: "#000",
//                                                                     fontSize: "14px",
//                                                                     marginBottom: "3px",
//                                                                     padding: "0px 10px 8px 10px",
//                                                                     borderRadius: '4px'
//                                                                 }}
//                                                             >
//                                                                 <div style={{ display: "flex", alignItems: "center", gap: "10px", flex: 2 }}>
//                                                                     <input
//                                                                         type="checkbox"
//                                                                         checked={!!selectedItems[item.itemId]}
//                                                                         onChange={(e) => {
//                                                                             e.stopPropagation();
//                                                                             handleCheckboxChangea(item.itemId);
//                                                                         }}
//                                                                     />
//                                                                     <span style={{ fontWeight: "600" }}>
//                                                                         {item.dishName || "Unnamed Dish"}
//                                                                     </span>
//                                                                 </div>
//                                                                 <div style={{ flex: 1, textAlign: 'start' }}>
//                                                                     × {item.updateQuantity ?? 0}
//                                                                 </div>
//                                                             </li>
//                                                         ))}
//                                                     </ul>
//                                                 )}

//                                                 {/* Non-TABLE_DINE_IN items */}
//                                                 <ul style={{ listStyle: "none", padding: 0, marginLeft: "10px", fontWeight: "bold" }}>
//                                                     {itemsList
//                                                         .filter((item) => item.status === "Okay")
//                                                         .map((item, idx) => (
//                                                             <li
//                                                                 key={idx}
//                                                                 style={{
//                                                                     color: "#000",
//                                                                     fontSize: "14px",
//                                                                     marginBottom: "3px",
//                                                                     display: "flex",
//                                                                     justifyContent: "space-between",
//                                                                     alignItems: "center",
//                                                                     padding: "0px 10px8px 10px",
//                                                                     borderRadius: '4px'
//                                                                 }}
//                                                                 onClick={(e) => e.stopPropagation()}
//                                                             >
//                                                                 <div style={{ display: "flex", alignItems: "center", gap: "8px", flex: 2 }}>
//                                                                     <input
//                                                                         type="checkbox"
//                                                                         checked={!!checkedItems[item.listId]}
//                                                                         onChange={() => handleCheckboxChange(item.listId)}
//                                                                     />
//                                                                     <span>{item.dishName}</span>
//                                                                 </div>
//                                                                 <div style={{ flex: 1, textAlign: 'start' }}>
//                                                                     × {item.quantity}
//                                                                 </div>
//                                                                 <div style={{ flex: 1, textAlign: 'right' }}>
//                                                                     <button
//                                                                         onClick={() => handleCancelSingleOrder(item.listId)}
//                                                                         style={{
//                                                                             padding: "4px 8px",
//                                                                             backgroundColor: "rgb(220, 53, 69)",
//                                                                             color: "white",
//                                                                             fontSize: "12px",
//                                                                             fontWeight: "bold",
//                                                                             border: "none",
//                                                                             borderRadius: "5px",
//                                                                             cursor: "pointer",
//                                                                         }}
//                                                                     >
//                                                                         Cancel
//                                                                     </button>
//                                                                 </div>
//                                                             </li>
//                                                         ))}
//                                                 </ul>
//                                             </div>
//                                         )}



//                                         {order.orderType === "TABLE_DINE_IN" && (
//                                             <div
//                                                 style={{
//                                                     display: "flex",
//                                                     justifyContent: "space-between",
//                                                     marginTop: "10px",
//                                                 }}
//                                             >
//                                                 <button
//                                                     onClick={(e) => handleAcceptOrderrsss(e, order.cartId)}
//                                                     style={{
//                                                         padding: "8px",
//                                                         backgroundColor: "rgb(177 93 198)",
//                                                         color: "white",
//                                                         fontSize: "14px",
//                                                         fontWeight: "bold",
//                                                         border: "none",
//                                                         borderRadius: "5px",
//                                                         cursor: "pointer",
//                                                     }}
//                                                 >
//                                                     Accept
//                                                 </button>
//                                                 <button
//                                                     onClick={(e) => {
//                                                         e.stopPropagation();
//                                                         handleAcceptOrderrss(e, order.cartId); // ✅ using cartId instead of itemId
//                                                     }}
//                                                     style={{
//                                                         padding: "8px",
//                                                         backgroundColor: "rgb(177 93 198)",
//                                                         color: "white",
//                                                         fontSize: "14px",
//                                                         fontWeight: "bold",
//                                                         border: "none",
//                                                         borderRadius: "5px",
//                                                         cursor: "pointer",
//                                                     }}
//                                                 >
//                                                     Decline
//                                                 </button>
//                                             </div>
//                                         )}




//                                         {/* Buttons for non-TABLE_DINE_IN orders */}
//                                         {order.orderType !== "TABLE_DINE_IN" && (
//                                             <div
//                                                 style={{
//                                                     display: "flex",
//                                                     justifyContent: "space-between",
//                                                     marginTop: "10px",
//                                                 }}
//                                             >
//                                                 <button
//                                                     onClick={(e) => handleAcceptOrderr(e, uniqueId)}
//                                                     style={{
//                                                         padding: "8px",
//                                                         backgroundColor: "rgb(177 93 198)",
//                                                         color: "white",
//                                                         fontSize: "14px",
//                                                         fontWeight: "bold",
//                                                         border: "none",
//                                                         borderRadius: "5px",
//                                                         cursor: "pointer",
//                                                     }}
//                                                 >
//                                                     Accept
//                                                 </button>
//                                                 <button
//                                                     onClick={(e) => handleDeclineOrder(e, uniqueId)}
//                                                     style={{
//                                                         padding: "8px",
//                                                         backgroundColor: "rgb(177 93 198)",
//                                                         color: "white",
//                                                         fontSize: "14px",
//                                                         fontWeight: "bold",
//                                                         border: "none",
//                                                         borderRadius: "5px",
//                                                         cursor: "pointer",
//                                                     }}
//                                                 >
//                                                     Decline
//                                                 </button>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             );
//                         })}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default MobileOrderspage;




import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import sound from "../../../../images/alaram.mp3";
import { ClipLoader } from "react-spinners"; // Add this import

const MobileOrderspage = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [expandedOrder, setExpandedOrder] = useState(null);
    const [orders, setOrders] = useState([]);
    const [checkedItems, setCheckedItems] = useState({});
    const [vendorId, setVendorId] = useState(null);
    const [loading, setLoading] = useState(true); // track loading state
    const scrollContainerRef = useRef(null);
    const notificationSound = new Audio(sound);
    
    // ✅ ADD THESE STATES - Same as Orders.js
    const [selectedItems, setSelectedItems] = useState({});

    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);

    // ✅ SAME AS Orders.js
    const handleCheckboxChange = (listId) => {
        setCheckedItems((prev) => ({
            ...prev,
            [listId]: !prev[listId],
        }));
        console.log("Selected List ID:", listId);
    };

    // ✅ SAME AS Orders.js - Fixed API endpoint
    const handleCancelSingleOrder = async (listId) => {
        try {
            const token = localStorage.getItem("authToken");
            
            if (!token) {
                alert("Authorization token not found!");
                return;
            }

            const response = await fetch(
                `https://backend.maamaas.com/food/api/orderscancellationlist/edit/${listId}`, // ✅ Added /api/
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        status: "Cancelled",
                    }),
                }
            );

            if (!response.ok) {
                console.error(`Failed to cancel order ${listId}`);
                alert(`Failed to cancel order ${listId}`);
            } else {
                console.log(`Order ${listId} cancelled successfully.`);
                alert(`Order ${listId} has been cancelled.`);
                // Optional: Uncheck after cancellation
                setCheckedItems((prev) => {
                    const updated = { ...prev };
                    delete updated[listId];
                    return updated;
                });
            }
        } catch (error) {
            console.error("Error cancelling order:", error);
        }
    };

    // ✅ SAME AS Orders.js
    const handleOrderClick = (order) => {
        const id = order.orderId || order.cartId;
        console.log("Clicked order:", order);

        if (expandedOrder && expandedOrder.id === id) {
            console.log("Collapsing order:", id);
            setExpandedOrder(null);
        } else {
            console.log("Expanding order:", id);
            setExpandedOrder({ ...order, id });
        }
    };

    // ✅ SAME AS Orders.js
    const handleCheckboxChangea = (itemId) => {
        setSelectedItems((prev) => ({
            ...prev,
            [itemId]: !prev[itemId],
        }));
    };

    // ✅ SAME AS Orders.js - TABLE_DINE_IN accept
    const handleAcceptOrderrsss = async (e, cartId) => {
        e.stopPropagation();

        const status = "PROCESSING";
        const note = "sds";
        const token = localStorage.getItem("authToken");

        if (!token) {
            console.error("🚨 Auth token not found in localStorage!");
            alert("You are not authorized. Please log in again.");
            return;
        }

        const itemIds = Object.keys(selectedItems).filter((id) => selectedItems[id]);

        if (itemIds.length === 0) {
            alert("Please select at least one item to accept.");
            return;
        }

        const url = `https://backend.maamaas.com/food/api/cart/cart/status/${cartId}?${itemIds
            .map((id) => `itemIds=${id}`)
            .join("&")}&status=${status}&note=${encodeURIComponent(note)}`;

        try {
            const response = await fetch(url, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Error: ${response.status} - ${errorText}`);
            }

            const data = await response.json();
            // Remove accepted order from list - SAME AS Orders.js
            setOrders((prev) => prev.filter((order) => order.cartId !== cartId));
            setSelectedItems({});

        } catch (error) {
            console.error("❌ Failed to update status:", error);
            alert("Failed to update item status. Please try again.");
        }
    };

    // ✅ SAME AS Orders.js - Normal order accept
    const handleAcceptOrderr = async (e, orderId) => {
        e.stopPropagation();

        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("Authentication token is missing.");
            return;
        }

        try {
            const response = await axios.put(
                `https://backend.maamaas.com/food/api/orders/edit-orders/${orderId}/CONFIRMED`,
                {
                    status: "CONFIRMED",
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            // Remove accepted order from list - SAME AS Orders.js
            setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
        } catch (error) {
            console.error("Failed to update order status:", error.response?.data || error.message);
        }
    };

    // ✅ ADD THIS FUNCTION - Same as Orders.js for TABLE_DINE_IN decline
    const handleAcceptOrderrss = async (e, cartId) => {
        e.stopPropagation();

        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("Authentication token is missing.");
            return;
        }

        try {
            const response = await axios.put(
                `https://backend.maamaas.com/food/api/orders/cancal/total/order/${cartId}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            // Remove declined order from list - SAME AS Orders.js
            setOrders((prev) => prev.filter((order) => order.cartId !== cartId));

        } catch (error) {
            console.error(
                "❌ Failed to update order status:",
                error.response?.data || error.message
            );

            if (error.response?.status === 403) {
                alert("Access denied. Your session may have expired — please log in again.");
            }
        }
    };

    // ✅ SAME AS Orders.js - Normal order decline
    const handleDeclineOrder = async (e, orderId) => {
        e.stopPropagation();

        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("Authentication token is missing.");
            return;
        }

        try {
            const response = await axios.put(
                `https://backend.maamaas.com/food/api/orders/cancal/total/order/${orderId}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            // Remove declined order from list - SAME AS Orders.js
            setOrders((prev) => prev.filter((order) => order.orderId !== orderId));

        } catch (error) {
            console.error(
                "❌ Failed to update order status:",
                error.response?.data || error.message
            );

            if (error.response?.status === 403) {
                alert("Access denied. Your session may have expired — please log in again.");
            }
        }
    };

    // ✅ SAME AS Orders.js - Fixed fetchOrders function
    const fetchOrders = async () => {
        if (!vendorId) return;

        const token = localStorage.getItem("authToken");
        if (!token) return;

        try {
            const vendorRes = await axios.get(
                `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            // Filter to show orders that are BOTH PENDING AND Online_Payment
            const filteredVendorOrders = vendorRes.data.filter(
                (order) => {
                    const isTableDineInPending = order.orderType === "TABLE_DINE_IN" && order.status === "PENDING";
                    const showOrder = order.status === "PENDING" &&
                        (order.paymentMethod === "Online_Payment" ||
                            order.paymentMethod === "ONLINE_PAYMENT");
                    return !isTableDineInPending && showOrder;
                }
            );

            const confirmedOrdersFromVendor = vendorRes.data.filter(
                (order) =>
                    Array.isArray(order.cartItems) &&
                    order.cartItems.some((item) => item.orderStatus === "CONFIRMED")
            );

            // Fetch TABLE_DINE_IN orders
            const statuses = ["PENDING", "CONFIRMED"];
            const dineInPromises = statuses.map((status) =>
                axios.get(
                    `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/${status}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                )
            );

            const dineInResponses = await Promise.all(dineInPromises);
            const dineInOrders = dineInResponses.flatMap((res) => res.data || []);

            // Filter TABLE_DINE_IN orders for PENDING AND Online_Payment
            const filteredDineInOrders = dineInOrders.filter(
                (order) => order.status === "PENDING" &&
                    (order.paymentMethod === "Online_Payment" ||
                        order.paymentMethod === "ONLINE_PAYMENT")
            );

            // Merge all results - only orders that are PENDING AND Online_Payment
            const allOrders = [...filteredVendorOrders, ...filteredDineInOrders];

            // For confirmed orders, include them as before
            const allOrdersWithConfirmed = [...allOrders, ...confirmedOrdersFromVendor];

            // Deduplicate
            const uniqueOrders = allOrdersWithConfirmed.filter(
                (order, index, self) =>
                    index ===
                    self.findIndex(
                        (o) =>
                            (o.cartId && o.cartId === order.cartId) ||
                            (o.orderId && o.orderId === order.orderId)
                    )
            );

            // Check for new orders
            const previousOrdersIds = orders.map((o) => o.orderId || o.cartId);
            const newOrders = uniqueOrders.filter(
                (o) => !previousOrdersIds.includes(o.orderId || o.cartId)
            );

            if (newOrders.length > 0) {
                notificationSound.play().catch((e) => console.warn("Autoplay prevented:", e));
            }

            setOrders(uniqueOrders);
        } catch (error) {
            console.error("Error fetching orders:", error.response?.data || error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrders();
        const intervalId = setInterval(fetchOrders, 5000);
        return () => clearInterval(intervalId);
    }, [vendorId]);

    // ✅ SAME AS Orders.js - Horizontal auto-scroll
    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        let interval = setInterval(() => {
            if (!isHovered) {
                scrollContainer.scrollLeft += 1;
                if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
                    scrollContainer.scrollLeft = 0;
                }
            }
        }, 20);

        return () => clearInterval(interval);
    }, [isHovered]);

    // ✅ SAME AS Orders.js
    const getOrderColor = (orderType) => {
        const normalized = (orderType || "").trim().toLowerCase();
        switch (normalized) {
            case "dine_in":
                return "#1E90FF";
            case "takeaway":
                return "#FF6347";
            case "delivery":
                return "#20B2AA";
            case "table_dine_in":
                return "#2051b2ff";
            default:
                return "#ccc";
        }
    };

    // ✅ ADD LOADING STATE - Same as Orders.js
    if (loading) {
        return (
            <div style={{
                position: "fixed",
                top: "60px",
                left: 0,
                right: 0,
                height: "200px",
                backgroundColor: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000
            }}>
                <ClipLoader color="#ff4081" size={60} />
            </div>
        );
    }

    return (
        <div>
            <style>
                {`
                @media (min-width: 768px) {
                .order-card{
                display:none !important;
                }
               
                }

             
        @media (max-width: 768px) {
        
          .mobile-orders-wrapper {
            width: 100%;
            left: 0;
            right: 0;
            top: 0px;
            height: auto;
            padding: 10px;
            border-radius: 0;
          }

         .mobile-scroll-container {
          display: flex;
          flex-direction: row;
          overflow-x: auto;
          gap: 12px;
          padding-bottom: 10px;
          scroll-behavior: smooth;
          margin-top: 60px;
          background:#fff;
          -ms-overflow-style: none;
          scrollbar-width: none;
        }

        .order-card {
          flex-shrink: 0;
          width: 280px;
          max-width: 90vw;
          border-radius: 10px;
          box-shadow: 0px 3px 6px rgba(0,0,0,0.15);
          padding: 12px;
          transition: all 0.3s ease-in-out;
        }

        }

        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }

        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        `}
            </style>

            <div
                className="mobile-orders-wrapper"
                style={{
                    position: "fixed",
                    right: "16px",
                    borderRadius: "8px",
                    padding: "10px",
                    marginTop: "40px",
                }}
            >
                <div
                    className="hide-scrollbar"
                    style={{
                        maxHeight: "600px",
                        overflowY: "auto",
                        paddingRight: "5px",
                    }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <div className="mobile-scroll-container" ref={scrollContainerRef}>
                        {orders.length === 0 ? (
                            <div style={{
                                width: "100%",
                                textAlign: "center",
                                padding: "40px",
                                color: "#777"
                            }}>
                                No orders found.
                            </div>
                        ) : (
                            orders.map((order, index) => {
                                const uniqueId = order.orderId || order.cartId;
                                const itemsList = order.items || order.order || order.cartItems || [];

                                const isExpanded =
                                    expandedOrder &&
                                    (expandedOrder.orderId === uniqueId || expandedOrder.cartId === uniqueId);

                                return (
                                    <div
                                        key={`${uniqueId}-${index}`}
                                        onClick={() => handleOrderClick(order)}
                                        className="order-card scroll-data-responsive"
                                        style={{
                                            cursor: "pointer",
                                            background: getOrderColor(order.orderType),
                                            position: "relative",
                                            height: isExpanded ? "auto" : "auto",
                                        }}
                                    >
                                        <div style={{ width: "100%" }}>
                                            {/* Header */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    color: "#fff",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                <div style={{ display: "flex" }}>
                                                    <div
                                                        style={{
                                                            color: "rgba(255, 255, 255, 0.9)",
                                                            marginRight: "10px",
                                                            fontSize: "18px",
                                                            transition: "transform 0.3s ease",
                                                            transform: expandedOrder?.orderId === order.orderId ? "rotate(180deg)" : "rotate(0deg)",
                                                        }}
                                                    >
                                                        ▼
                                                    </div>
                                                    Order ID: #{uniqueId}
                                                </div>
                                                <h5 style={{ marginTop: "0px" }}>
                                                    {order.orderType === "DINE_IN" ? "DINEIN" : order.orderType || "N/A"}
                                                </h5>
                                            </div>

                                            {isExpanded && (
                                                <div style={{ marginTop: "-10px" }}>
                                                    {/* Headers for items list */}
                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        padding: '8px 10px',
                                                        borderRadius: '4px',
                                                        marginBottom: '0px',
                                                        fontWeight: 'bold',
                                                        fontSize: '16px',
                                                        color: '#fff'
                                                    }}>
                                                        <div style={{ flex: 0, textAlign: 'left' }}>Items</div>
                                                        <div style={{ flex: 1, textAlign: 'center' }}>Quantity</div>
                                                    </div>

                                                    {order.orderType === "TABLE_DINE_IN" && (
                                                        <ul
                                                            style={{ listStyle: "none", padding: 0, marginLeft: "10px", fontWeight: "bold" }}
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            {itemsList.map((item, idx) => (
                                                                <li
                                                                    key={idx}
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        color: "#000",
                                                                        fontSize: "14px",
                                                                        marginBottom: "3px",
                                                                        padding: "0px 10px 8px 10px",
                                                                        borderRadius: '4px'
                                                                    }}
                                                                >
                                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px", flex: 2 }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={!!selectedItems[item.itemId]}
                                                                            onChange={(e) => {
                                                                                e.stopPropagation();
                                                                                handleCheckboxChangea(item.itemId);
                                                                            }}
                                                                        />
                                                                        <span style={{ fontWeight: "600" }}>
                                                                            {item.dishName || "Unnamed Dish"}
                                                                        </span>
                                                                    </div>
                                                                    <div style={{ flex: 1, textAlign: 'start' }}>
                                                                        × {item.updateQuantity ?? 0}
                                                                    </div>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}

                                                    {/* Non-TABLE_DINE_IN items */}
                                                    <ul style={{ listStyle: "none", padding: 0, marginLeft: "10px", fontWeight: "bold" }}>
                                                        {itemsList
                                                            .filter((item) => item.status === "Okay")
                                                            .map((item, idx) => (
                                                                <li
                                                                    key={idx}
                                                                    style={{
                                                                        color: "#000",
                                                                        fontSize: "14px",
                                                                        marginBottom: "3px",
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        padding: "0px 10px8px 10px",
                                                                        borderRadius: '4px'
                                                                    }}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    <div style={{ display: "flex", alignItems: "center", gap: "8px", flex: 2 }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={!!checkedItems[item.listId]}
                                                                            onChange={() => handleCheckboxChange(item.listId)}
                                                                        />
                                                                        <span>{item.dishName}</span>
                                                                    </div>
                                                                    <div style={{ flex: 1, textAlign: 'start' }}>
                                                                        × {item.quantity}
                                                                    </div>
                                                                    <div style={{ flex: 1, textAlign: 'right' }}>
                                                                        <button
                                                                            onClick={() => handleCancelSingleOrder(item.listId)}
                                                                            style={{
                                                                                padding: "4px 8px",
                                                                                backgroundColor: "rgb(220, 53, 69)",
                                                                                color: "white",
                                                                                fontSize: "12px",
                                                                                fontWeight: "bold",
                                                                                border: "none",
                                                                                borderRadius: "5px",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    </div>
                                                                </li>
                                                            ))}
                                                    </ul>
                                                </div>
                                            )}

                                            {/* Buttons for TABLE_DINE_IN */}
                                            {order.orderType === "TABLE_DINE_IN" && (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        marginTop: "10px",
                                                    }}
                                                >
                                                    <button
                                                        onClick={(e) => handleAcceptOrderrsss(e, order.cartId)}
                                                        style={{
                                                            padding: "8px",
                                                            backgroundColor: "rgb(177 93 198)",
                                                            color: "white",
                                                            fontSize: "14px",
                                                            fontWeight: "bold",
                                                            border: "none",
                                                            borderRadius: "5px",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        Accept
                                                    </button>
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleAcceptOrderrss(e, order.cartId);
                                                        }}
                                                        style={{
                                                            padding: "8px",
                                                            backgroundColor: "rgb(177 93 198)",
                                                            color: "white",
                                                            fontSize: "14px",
                                                            fontWeight: "bold",
                                                            border: "none",
                                                            borderRadius: "5px",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        Decline
                                                    </button>
                                                </div>
                                            )}

                                            {/* Buttons for non-TABLE_DINE_IN */}
                                            {order.orderType !== "TABLE_DINE_IN" && (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        marginTop: "10px",
                                                    }}
                                                >
                                                    <button
                                                        onClick={(e) => handleAcceptOrderr(e, uniqueId)}
                                                        style={{
                                                            padding: "8px",
                                                            backgroundColor: "rgb(177 93 198)",
                                                            color: "white",
                                                            fontSize: "14px",
                                                            fontWeight: "bold",
                                                            border: "none",
                                                            borderRadius: "5px",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        Accept
                                                    </button>
                                                    <button
                                                        onClick={(e) => handleDeclineOrder(e, uniqueId)}
                                                        style={{
                                                            padding: "8px",
                                                            backgroundColor: "rgb(177 93 198)",
                                                            color: "white",
                                                            fontSize: "14px",
                                                            fontWeight: "bold",
                                                            border: "none",
                                                            borderRadius: "5px",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        Decline
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileOrderspage;